export const WORKER_TYPE_FIELD = 'worker_type';
export const WORKER_ORTHOTRAC = 'orthotrac';
export const WORKER_PRACTICEWORKS = 'practiceworks';
export const WORKER_WINOMS = 'winoms';
export const WORKER_SOFTDENT = 'softdent';
export const WORKER_DENTRIX = 'dentrix';
export const WORKER_EAGLESOFT = 'eaglesoft';
export const WORKER_OPENDENTAL = 'open dental';
export const WORKER_CURVEDENTAL = 'curve dental';
export const WORKER_QSI = 'qsi';
export const WORKER_DENTICON = 'denticon';
export const WORKER_KOLLA = 'kolla';
export const WORKER_CLOUD9 = 'cloud9';
export const WORKER_CARESTACK = 'carestack';
export const WORKER_CLIENT = 'client';
export const CAN_START_SYNC = [WORKER_DENTICON, WORKER_QSI, WORKER_CURVEDENTAL, WORKER_KOLLA, WORKER_CLOUD9, WORKER_CARESTACK];
export const PMS_PASSWORD_NOT_REQUIRED = [WORKER_KOLLA, WORKER_CLIENT];

export const KOLLA_CONNECTORS = {
  [WORKER_DENTRIX]: process.env.REACT_APP_DEPLOY_ENV === 'prod' ? 'dentrix-g7-1461' : 'dentrix-g7-79218',
  [WORKER_EAGLESOFT]: process.env.REACT_APP_DEPLOY_ENV === 'prod' ? 'eaglesoft-40887' : 'eaglesoft-26545',
  [WORKER_OPENDENTAL]:  process.env.REACT_APP_DEPLOY_ENV === 'prod' ? 'opendental-22075' : 'opendental-28471'
};

export const canSelfServe = (worker_type, pms_type) => {
  if (worker_type !== WORKER_KOLLA) {
    return false;
  }
  switch (pms_type) {
    case WORKER_DENTRIX:
    case WORKER_EAGLESOFT:
    case WORKER_OPENDENTAL:
      return true;
    default:
      return false;
  }
};
